import React, { Component } from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import UploadDeviceSoftware from './upload'

import {
  dateTimeFormatter
} from '../../../common/utils'

class SettingsDeviceSoftware extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }
    this.handleClose = this.handleClose.bind(this)
  }
  showModal(e) {
    this.setState({
      modal: true
    })
  }
  handleClose(e) {
    this.setState({
      modal: false
    })
  }
  render() {
    const { classes, translate, uploadDeviceSoftware, log } = this.props
    const { modal } = this.state

    let $modal = modal ? (
      <UploadDeviceSoftware
        translate={translate}
        onClose={this.handleClose}
        uploadDeviceSoftware={uploadDeviceSoftware}
      />
    ) : (null)
    return (
      <div>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="headline" color="inherit">
                {translate("settings_devicesoftware")}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.info}>
              <Typography type="subheading" color="inherit">
                {translate("settings_device_software_label")}
              </Typography>
              <Typography type="caption" color="inherit" className={classes.uppercase}>
                {translate("settings_current_version")} <b>{(log && log.softwareupdate) ? log.softwareupdate.name : ''}</b>
              </Typography>
              <Typography type="caption" color="inherit" className={classes.uppercase}>
                {translate("settings_date_uploaded")} <b>{(log && log.softwareupdate) ? dateTimeFormatter(log.softwareupdate.createdat) : ''}</b>
              </Typography>
              {/* <Typography type="subheading" color="inherit">
                {translate("settings_device_software_release_notes_label")}
              </Typography>
              <Typography type="caption" color="inherit">
                {translate("settings_current_version")} <b>{(log && log.softwareupdatereleasenote) ? log.softwareupdatereleasenote.name : ''}</b>
              </Typography>
              <Typography type="caption" color="inherit">
                {translate("settings_date_uploaded")} <b>{(log && log.softwareupdatereleasenote) ? new Date(log.softwareupdatereleasenote.createdat + 'z').toLocaleString() : ''}</b>
              </Typography> */}
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                raised
                className={classes.orangeButton}
                onClick={(e) => this.showModal(e)}
              >{translate("settings_upload")}</Button>
            </Grid>
          </Grid>
        </Paper>
        {$modal}
      </div>

    )
  }

}

export default withStyles(styles)(SettingsDeviceSoftware)
